import React, { memo, useEffect, useState } from "react";

// eslint-disable-next-line react/display-name
const NewOwner = memo(({
                         allPossibleOwners,
                         handleChange,
                       }) => {
  const [ownerId, setOwnerId] = useState("");
  const [ownerPercent, setOwnerPercent] = useState(0);

  useEffect(() => {
    if (allPossibleOwners.length) {
      setOwnerId(allPossibleOwners[0].id);
    }
  }, [allPossibleOwners]);

  const handleChangeOwner = (ev) => {
    setOwnerId(ev.target.value);
  };

  const handleAdd = () => {
    const fixedPercent = Number(ownerPercent);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(fixedPercent) || fixedPercent <= 0 || fixedPercent > 100 || !ownerId) {
      return null;
    }

    handleChange({
      id: ownerId,
      fullname: allPossibleOwners.find(possibleOwner => possibleOwner.id === ownerId).name,
      percent: ownerPercent
    });
    setOwnerPercent(0);
    setOwnerId(0);
  };

  return (
    <div className="form-group form-group-sm mb-0">
      <div className="input-group input-group-sm">
        <div className="input-group-prepend w-25">
          <select className="form-control form-control-sm" onChange={handleChangeOwner} value={ownerId}>
            {!allPossibleOwners.length ?
              <option value={0}>No other available owners...</option>
              : null}
            {allPossibleOwners.map((owner) => (
              <option key={owner.id}>{owner.name}</option>
            ))}
          </select>
        </div>
        <input
          className="form-control" type="number"
          value={ownerPercent}
          max={100}
          min={0}
          onChange={(ev) => setOwnerPercent(Number(ev.target.value))}
        />
        <div className="input-group-append">
          <span className="input-group-text">%</span>
        </div>
        <div className="input-group-append">
          <button className="btn btn-success" onClick={handleAdd} disabled={!ownerId || !ownerPercent}>Add</button>
        </div>
      </div>
    </div>
  );
});

export default NewOwner;



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/NewOwner.js